import styled from 'styled-components';
import { Link } from 'react-router-dom';
import theme from 'theme/theme';

const Wrapper = styled.div`
	width: 100%;
	padding: 4px 16px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	gap: 4px 12px;
	background-color: ${theme.background3};
`;

const Text = styled.span`
	font-weight: 400;
	font-size: 12px;
`;

const FooterLink = styled(Link)`
	font-weight: 400;
	font-size: 12px;
	color: ${theme.text1};
	text-decoration: underline;
	opacity: 0.75;

	&:hover {
		opacity: 1;
		color: ${theme.primary1};
	}
`;

export { Wrapper, Text, FooterLink };
